<!--
 * @Author: LeeHuiXian
 * @version: 
 * @Date: 2020-04-30 17:20:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-06-06 17:05:16
 * @FilePath: /goldenSalesMobile/src/views/UsersOrder/ConsumeCode/index.vue
 * @Description: 消费码详情页
-->
<template>
  <div class="page-container">
    <div class="store-name">
      <img src="../../../assets/common_image/store_icon.png" alt="" />
      <span>{{ tenantName }}</span>
    </div>
    <div class="code-wrap" v-for="(item, index) in codeList" :key="index">
      <div class="code-name">
        <span>{{ item.ProductName }}</span>
        <span>X {{ item.Quantity }}</span>
      </div>
      <!-- 一单一码 -->
      <div class="code-box" v-if="item.ProductQrCodeMode.Id === 1">
        <!-- 状态标记 -->
        <div class="code-statusFlag" v-if="item.Status && item.Status.Id !== 0">
          <svg-icon
            v-if="item.Status && item.Status.Id === 3"
            iconClass="finished"
          />
          <svg-icon
            v-if="item.Status && item.Status.Id === 1"
            iconClass="refunding"
          />
          <svg-icon
            v-if="item.Status && item.Status.Id === 2"
            iconClass="returned"
          />
          <svg-icon
            v-if="item.Status && item.Status.Id === 4"
            iconClass="overdue"
          />
        </div>
        <!-- 条形码 -->
        <js-barcode :value="item.Tickets[0].Code" />
        <!-- 二维码组件 -->
        <vue-qr
          :logoSrc="codeLogoSrc"
          :text="item.Tickets[0].Code.toString()"
          :size="200"
        />
      </div>
      <!-- 一单多码 -->
      <div v-if="item.ProductQrCodeMode.Id === 2">
        <div
          class="code-box"
          v-for="(subItem, subIndex) in item.Tickets"
          :key="subIndex"
        >
          <!-- 状态标记 -->
          <div
            class="code-statusFlag"
            v-if="subItem.Status && subItem.Status.Id !== 1"
          >
            <svg-icon
              v-if="subItem.Status && subItem.Status.Id === 2"
              iconClass="used"
            />
            <svg-icon
              v-if="subItem.Status && subItem.Status.Id === 3"
              iconClass="refunding"
            />
            <svg-icon
              v-if="subItem.Status && subItem.Status.Id === 4"
              iconClass="returned"
            />
            <svg-icon
              v-if="subItem.Status && subItem.Status.Id === 5"
              iconClass="overdue"
            />
          </div>
          <!-- 条形码 -->
          <js-barcode :value="subItem.Code" />
          <!-- 二维码组件 -->
          <vue-qr
            :logoSrc="codeLogoSrc"
            :text="subItem.Code.toString()"
            :size="200"
          />
          <!-- text是要生成二维码的内容 -->
        </div>
      </div>
      <div class="status-num">
        <p>
          <span v-if="item.UseableNum > 0 && item.UseableNum < item.Quantity"
            >剩余可用数量: {{ item.UseableNum }}</span
          >
          <span v-if="item.UsedNum > 0 && item.UsedNum < item.Quantity"
            >已使用数量: {{ item.UsedNum }}</span
          >
          <span v-if="item.RefundNum > 0 && item.RefundNum < item.Quantity"
            >已退款数量: {{ item.RefundNum }}</span
          >
          <span
            v-if="item.RefundingNum > 0 && item.RefundingNum < item.Quantity"
            >退款中数量: {{ item.RefundingNum }}</span
          >
        </p>
      </div>
      <p class="code-validTime">
        有效期：{{ `${item.UseStartDate} - ${item.UseEndDate}` }}
      </p>
    </div>
    <div class="use-explain">
      <h3>使用方法</h3>
      <p>1.打开公众号-我的订单-查看详情进行使用</p>
      <p>2.让营业员扫码核销</p>
      <p>3.打开二维码对准闸机刷卡处</p>
      <p>4.请在有效期内使用</p>
    </div>
  </div>
</template>

<script>
import { getOrderDetail } from "@/api/order";
import { arrayGroupBy } from "@/utils/index";

export default {
  data() {
    return {
      orderId: this.$route.params.id,
      codeLogoSrc: require("../../../assets/common_image/codelogo.png"),
      codeList: [],
      tenantName: "", // 渠道（商户）名称
    };
  },

  created() {
    this.orderId = this.$route.params.id;
    console.log(
      "%c this.$route ",
      "background-image:color:transparent;color:yellow;font-size:2em"
    );
    console.log(this.$route);
    getOrderDetail({ query: { id: this.orderId } })
      .then((res) => {
        let orderData = res.Items;
        if (orderData instanceof Array && orderData.length > 0) {
          this.tenantName = orderData[0].TenantName;
          orderData.map((item) => {
            // TODO 删除测试数据
            // if(item.Id === 299792530) {
            //   item.Details = [
            //     {
            //       Id: 299792530,
            //       CreateTime: "2020-05-09 09:34:41",
            //       ProductShelfName: "双人门票（成人测试123）",
            //       Quantity: 1,
            //       Status: {Id: 5, Name: "全部取消", Code: null},
            //       Tickets: [
            //         {
            //           Code: 811312961122,
            //           UsedTime: null,
            //           Status: {
            //             Id: 4,
            //             Name: '已退票'
            //           }
            //         },
            //         {
            //           Code: 811312961122,
            //           UsedTime: null,
            //           Status: {
            //             Id: 2,
            //             Name: '已使用'
            //           }
            //         },
            //         {
            //           Code: 811312961122,
            //           UsedTime: null,
            //           Status: {
            //             Id: 1,
            //             Name: '未使用'
            //           }
            //         }
            //       ],
            //       UseEndDate: "2020-11-05 00:00:00",
            //       UseStartDate: "2020-05-09 00:00:00",
            //     }
            //   ]
            // }
            // 计算票的可用数量、已用数量、已退款数量、退款中数量
            item.Details.map((subItem) => {
              let sortedTickets = arrayGroupBy(
                subItem.Tickets,
                function (ticket) {
                  return ticket.Status ? [ticket.Status.Id] : null;
                }
              );
              console.log("详情-------------------");
              console.log(sortedTickets);
              sortedTickets.map((sort) => {
                if (sort[0].Status) {
                  switch (sort[0].Status.Id) {
                    case 1:
                      subItem.UseableNum = sort.length;
                      break;
                    case 2:
                      subItem.UsedNum = sort.length;
                      break;
                    case 3:
                      subItem.RefundingNum = sort.length;
                      break;
                    case 4:
                      subItem.RefundNum = sort.length;
                      break;
                  }
                }
              });
            });
            console.log(item.Details);
            this.codeList = this.codeList.concat(item.Details); // 取出消费码数据
          });
        }
      })
      .catch((err) => {
        // console.log(err)
      });
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  @include border-box(120px 0 70px);

  .store-name {
    @include flex-box(center);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100px;
    background: #fff;

    > img {
      width: 60px;
      height: 60px;
      margin-right: 20px;
      border-radius: 50%;
    }

    > span {
      font-size: 30px;
      font-weight: 500;
      color: $secondFontColor;
    }
  }

  .code-wrap {
    width: 690px;
    margin: 0 auto 20px;
    box-shadow: 0px 0px 14px 0px rgba(182, 182, 182, 0.5);
    border-radius: 10px;
    background: #fff;

    .code-name {
      @include flex-box(center);
      width: 100%;
      height: 80px;
      font-size: 28px;
      border-bottom: 1px solid #e6e6e6;

      > span:first-child {
        color: $baseFontColor;
        margin-right: 20px;
      }

      > span:last-child {
        color: #cca567;
      }
    }

    .code-box {
      @include flex-box(center);
      flex-direction: column;
      position: relative;
      margin: 50px auto 0;

      .code-statusFlag {
        @include flex-box(center);
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.5);
      }

      .svg-icon {
        width: 400px;
        height: 400px;
      }
    }

    .code-validTime {
      @include flex-box(center);
      width: 100%;
      height: 80px;
      font-size: 26px;
      color: $baseFontColor;
      border-top: 1px solid #e6e6e6;
    }

    .status-num {
      > p {
        text-align: center;
        line-height: 32px;
        font-size: 24px;
        color: $baseFontColor;

        > span {
          margin-right: 20px;
        }
      }
    }
  }

  .use-explain {
    width: 690px;
    margin: 0 auto;
    padding-bottom: 30px;
    box-shadow: 0px 0px 14px 0px rgba(182, 182, 182, 0.5);
    border-radius: 10px;
    background: #fff;

    > h3 {
      @include border-box(0 65px);
      width: 100%;
      height: 80px;
      margin-bottom: 30px;
      line-height: 80px;
      font-size: 28px;
      font-weight: normal;
      color: $secondFontColor;
      border-bottom: 1px solid #e6e6e6;
    }

    > p {
      @include border-box(0 35px 0 65px);
      width: 100%;
      line-height: 1.5;
      font-size: 26px;
      color: $baseFontColor;
    }
  }
}
</style>
